import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { selectBackgroundStyle, selectBadgeStyle, selectLayoutFlow, ImageContentBlock, PlainContentModuleContainer, TextContentBlock, WaveContentModuleContainer } from "@silvertours/front-entities";
import { Ui } from "@silvertours/front-shared";
import { getSpacingDirectionFromImagePosition } from "../../particle";
export var TextImage = function(props) {
    var badge = props.badge, image = props.image, _rules = props.rules, rules = _rules === void 0 ? {} : _rules;
    var style = rules.style || "default";
    var imagePosition = rules.imagePosition || "right";
    var backgroundStyle = selectBackgroundStyle(style);
    var badgeStyle = selectBadgeStyle(style);
    var isPlain = ![
        "green",
        "mint",
        "orange"
    ].includes(style);
    var layoutFlow = selectLayoutFlow(imagePosition);
    var spacingDirection = getSpacingDirectionFromImagePosition(imagePosition);
    var moduleContainerRules = {
        backgroundStyle: backgroundStyle,
        layoutFlow: layoutFlow,
        verticalSpacing: {
            isLarge: !!image,
            spacingDirection: spacingDirection
        }
    };
    var ContentModuleContainer = isPlain ? PlainContentModuleContainer : WaveContentModuleContainer;
    return /*#__PURE__*/ _jsxs(ContentModuleContainer, {
        rules: moduleContainerRules,
        children: [
            /*#__PURE__*/ _jsx(TextContentBlock, {
                content: props,
                rules: {
                    badge: {
                        shouldHide: imagePosition === "top",
                        style: badgeStyle
                    },
                    isContainerMultiColumn: !!image,
                    isSecondColumn: imagePosition === "left",
                    textStyle: {
                        style: isPlain ? Ui.RichTextStyle.Primary : Ui.RichTextStyle.Alternative
                    },
                    verticalSpacing: {
                        isLargeAtXL: image && !isPlain,
                        isSmallAtXL: image && isPlain
                    }
                }
            }),
            /*#__PURE__*/ _jsx(ImageContentBlock, {
                content: props,
                rules: {
                    badge: {
                        shouldHide: imagePosition !== "top",
                        style: badgeStyle
                    },
                    imagePosition: imagePosition,
                    isFirstColumn: imagePosition === "left",
                    verticalSpacing: {
                        isLargeAtLG: badge && !isPlain,
                        isNoneAtXL: !isPlain
                    }
                }
            })
        ]
    });
};
